import { render, staticRenderFns } from "./ConversationComposer.vue?vue&type=template&id=8c71b3c4&scoped=true&"
import script from "./ConversationComposer.vue?vue&type=script&lang=js&"
export * from "./ConversationComposer.vue?vue&type=script&lang=js&"
import style0 from "./ConversationComposer.vue?vue&type=style&index=0&id=8c71b3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c71b3c4",
  null
  
)

export default component.exports